import { ConfigProvider, Form, Select } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import {
  useSteeringChartFilters,
  useSteeringChartFiltersFormName,
} from 'business/steering/providers/steering-chart-filters-provider';
import { Position } from 'business/steering/providers/steering-filters-provider/types';
import { SliderWithInputNumber } from 'ui/form/slider-with-input-number';

const MIN_TOLERANCE_FILTER = 0;
const MAX_TOLERANCE_FILTER = 1000;

export const SteeringChartFilters = () => {
  const { t } = useTranslation();
  const formName = useSteeringChartFiltersFormName();

  const filters = useSteeringChartFilters();

  const [form] = Form.useForm();

  const { currentConstructionSite } = useAppContext();

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Form
        layout={'inline'}
        form={form}
        name={formName}
        initialValues={filters}
      >
        <Form.Item
          name="position"
          layout="vertical"
          label={t('steering.filters.position.label')}
        >
          <Select<Position>
            popupMatchSelectWidth={false}
            options={
              [
                {
                  label: t('steering.filters.position.rear'),
                  value: 'rear',
                },
                {
                  label: t('steering.filters.position.front'),
                  value: 'front',
                },
                ...(currentConstructionSite?.isArticulated
                  ? [
                      {
                        label: t('steering.filters.position.cuttingWheel'),
                        value: 'cuttingWheel',
                      } as const,
                    ]
                  : []),
              ] satisfies { label: string; value: Position }[]
            }
          />
        </Form.Item>
        <Form.Item
          name="scale"
          layout="vertical"
          label={t('steering.filters.scale')}
        >
          <SliderWithInputNumber
            min={MIN_TOLERANCE_FILTER}
            max={MAX_TOLERANCE_FILTER}
            step={5}
          />
        </Form.Item>
      </Form>
    </ConfigProvider>
  );
};
